import { forwardRef, type PropsWithChildren, type ReactNode } from 'react';
import { Button, type ButtonProps } from 'react-aria-components';
import { twMerge } from 'tailwind-merge';

import { CircularProgress } from './circular-progress';

type Props = PropsWithChildren<{
  icon?: ReactNode;
  loading?: boolean;
  iconClassName?: string;
}> &
  ButtonProps &
  React.RefAttributes<HTMLButtonElement>;

export const PrimaryButton = forwardRef<HTMLButtonElement, Props>(function PrimaryButton(
  { loading, icon, type = 'submit', iconClassName, ...rest },
  ref,
) {
  const { children, isDisabled, className, ...props } = rest;

  return (
    <Button
      {...props}
      ref={ref}
      isDisabled={isDisabled || loading}
      type={type}
      className={twMerge(
        'flex h-[44px] w-full items-center justify-center gap-[5px] rounded-[4px] bg-primary text-[14px] text-white hover:opacity-70 disabled:cursor-not-allowed disabled:opacity-40',
        `${className}`,
      )}
    >
      {children}
      {loading && <CircularProgress className={twMerge('h-[12px] w-[12px] text-white', iconClassName)} />}
      {!loading && icon}
    </Button>
  );
});
